import { SelectField, SelectFieldProps } from '@mews-commander/form';
import {
    getAllCurrencyOptions,
    getCurrentEnterpriseCurrencyOptions,
} from '@mews-commander/legacy-entities/src/ducks/currencies';
import { Option } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';

interface CurrencySelectFieldProps extends Omit<SelectFieldProps, 'options'> {
    currencyScope: 'all' | 'currentEnterprise';
}

const matchCurrencyScopeSelector = (currencyScope: CurrencySelectFieldProps['currencyScope']) => {
    switch (currencyScope) {
        case 'all':
            return getAllCurrencyOptions;
        case 'currentEnterprise':
            return getCurrentEnterpriseCurrencyOptions;
    }
};

export const CurrencySelectField = ({ currencyScope, ...other }: CurrencySelectFieldProps) => {
    const currencyOptions = useCommanderSelector(matchCurrencyScopeSelector(currencyScope)) as unknown as Array<Option>;
    return <SelectField {...other} options={currencyOptions} />;
};
